import IntrinsicValueSummary from './IntrinsicValueSummary';

export default IntrinsicValueSummary;
